{
  "topMenu": {
    "dihTitle": "Data Intelligence Hub",
    "dihSubTitle": "Extrae valor de los datos de forma segura",
    "logout": "Cerrar sesión",
    "dihPortal": "Portal DIH",
    "cofinityDataspace": "Portal del espacio de datos"
  },
  "userLogoutAlert": {
    "title": "¿Estás seguro de que deseas cerrar sesión?",
    "back": "Volver",
    "logout": "Cerrar sesión"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Inicio",
    "collapse": "Colapsar barra lateral",
    "help": "Ayuda",
    "prepare": "Gestión de modelos",
    "model": "Modelo de datos",
    "mapping": "Mapeo de datos",
    "converter": "Convertidor de datos",
    "provide": "Proveer",
    "publishData": "Publicar datos",
    "assets": "Activos",
    "policyPublicationTemplate": "Plantilla de publicación de políticas",
    "uploadHistory": "Historial de carga de activos",
    "consume": "Consumir",
    "searchDataOffers": "Buscar ofertas de datos",
    "negotiatedDataOffers": "Ofertas de datos negociadas",
    "downloadHistory": "Historial de descarga de activos",
    "govern": "Gobernar",
    "myPolicies": "Mis políticas",
    "createPolicies": "Crear políticas",
    "policyTemplate": "Plantillas de políticas",
    "manageAndConfig": "Configurar",
    "connections": "Gestionar conectores",
    "jobs": "Registros de procesos",
    "monitoring": "Monitorizar",
    "licences": "Licencias",
    "providedAgreements": "Acuerdos de contrato proporcionados",
    "incomingAgreements": "Ofertas de datos entrantes",
    "consumedAgreements": "Acuerdos de contrato consumidos",
    "consumeAutomation": "Automatización de consumo de políticas",
    "networkAnalytics": "Analítica de red",
    "otherLogs": "Otros registros",
    "digitalTwin": "Navegador de gemelos digitales",
    "messagesBrowserInbound": "Mensajes entrantes",
    "messagesBrowserOutbound": "Mensajes salientes",
    "applications": "Aplicaciones",
    "pcfExchange": "Intercambio PCF",
    "pcfRequests": "Solicitudes de datos PCF",
    "pcfExchangeHistory": "Historial de intercambio de datos PCF",
    "publicationTemplates": "Plantillas de publicación",
    "certificateManagement": "Gestión de certificados",
    "certificates": "Certificados",
    "connectors": "Mis conectores",
    "contractDefinitions": "Mis definiciones de contrato"
  },
  "versionModal": {
    "title": "Información general",
    "error": "No se pudieron obtener los detalles de la versión",
    "table": {
      "title": "Detalles del componente",
      "componentName": "Nombre del componente",
      "imageVersion": "Versión de la imagen",
      "chartVersion": "Versión de la lista"
    }
  },
  "dropdown": {
    "selectAll": "Seleccionar todo",
    "noOption": "No hay opciones disponibles",
    "noSuchOption": "No existe tal opción ...",
    "selectConnection": "Selecciona una conexión"
  },
  "certificateManagement": {
    "title": "Gestión de Certificados de Socios Comerciales",
    "description": "Bienvenido a la solución de intercambio de gestión de certificados de socios comerciales de extremo a extremo fácil de usar en Catena-X.",
    "howTo": {
      "description": "Descubre el catálogo de ofertas de datos de otras empresas miembros de Catena-X. Puedes buscar, seleccionar y suscribirte a una oferta de certificado. Puedes buscar ofertas de certificados usando el nombre de la empresa.",
      "doc": "¿Quieres saber más sobre cómo funciona la gestión de certificados de socios comerciales?"
    },
    "landingTiles": {
      "tile_1": {
        "title": "Certificado de publicación",
        "description": "Cree y comparta sus certificados de sitio en la red Catena-X."
      },
      "tile_2": {
        "title": "Descubrir y consumir certificados",
        "description": "Busque y descargue fácilmente certificados de sitios y empresas."
      },
      "tile_3": {
        "title": "Historial de publicación de certificados",
        "description": "Resumen de todos tus certificados proporcionados"
      },
      "tile_4": {
        "title": "Historial de certificados consumidos",
        "description": "Resumen de todos tus certificados consumidos"
      },
      "tile_5": {
        "title": "Solicitudes entrantes de certificados",
        "description": "Resumen de las solicitudes entrantes para compartir certificados"
      },
      "tile_6": {
        "title": "Estado de certificados salientes",
        "description": "Resumen de las acciones para compartir certificados"
      },
      "tile_7": {
        "title": "Solicitar certificados",
        "description": "Busque y descargue fácilmente certificados de sitios y empresas."
      }
    },
    "recentCertificateRequests": "Solicitudes recientes de datos de certificados entrantes",
    "learnMore": "Más información sobre la gestión de certificados",
    "requestCertificates": "Solicitar nuevos certificados",
    "pushCertificate": "Enviar certificado",
    "pushDescription": "El certificado existente se compartirá con el socio seleccionado a continuación. Tenga en cuenta que se aplicará el mismo conjunto de políticas que en la oferta original. Si desea cambiar las políticas, cree una nueva oferta de datos.",
    "pushSuccess": "¡Se ha iniciado el proceso de envío de certificados! El ID de trabajo es {id}",
    "receiverBpn": "Receptor BPN",
    "providerBpn": "BPN del proveedor",
    "locationBpns": "Sitio BPNA/BPNS",
    "certificateType": "Tipo de certificado",
    "requestSuccess": "¡Solicitud de certificado enviada correctamente!",
    "pushResult": "{successful} de {total} solicitudes {status} exitosas",
    "receiveConfirmTitle": "Reconocer recepción del certificado",
    "receiveConfirmDesc": "Al hacer clic en Sí, usted reconoce haber recibido el certificado compartido por el socio. El proveedor recibirá su confirmación. Luego, puede aceptar o rechazar el certificado.",
    "acceptedConfirmTitle": "Aceptar certificado",
    "acceptedConfirmDesc": "Al hacer clic en Sí, acepta que el certificado cumple con las expectativas. Puede descargar el certificado en PDF haciendo clic en el ícono de vista.",
    "rejectedConfirmTitle": "Rechazar certificado",
    "rejectedConfirmDesc": "Al hacer clic en Sí, usted rechaza el certificado entrante. El proveedor será notificado del rechazo y podrá compartirlo nuevamente o usted podrá solicitar uno nuevo.",
    "processStarted": "'{type}' ¡Proceso iniciado! El ID del trabajo es {id}",
    "certificateDetails": "Detalles del certificado",
    "availableCertificate": "Ubicación del certificado disponible",
    "updateSuccess": "¡Certificado actualizado con éxito!",
    "updateFailure": "¡Falló la actualización del certificado!"
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Información básica del certificado",
        "issuer": "Información del emisor",
        "validity": "Período de validez",
        "trust": "Información de confianza",
        "validator": "Información del validador",
        "application": "Área de aplicación",
        "enclosedSites": "Sitios incluidos"
      },
      "fields": {
        "businessPartnerNumber": "Número de socio comercial",
        "registrationNumber": "Número de registro",
        "certificateType": "Tipo de certificado",
        "certificateVersion": "Versión del certificado",
        "issuerName": "Nombre del emisor",
        "issuerBpn": "BPN del emisor",
        "validFrom": "Válido desde",
        "validUntil": "Válido hasta",
        "trustLevel": "Nivel de confianza",
        "uploaderBpn": "BPN del cargador",
        "validatorBpn": "BPN del validador",
        "validatorName": "Nombre del validador",
        "areaOfApplication": "Área de aplicación",
        "siteBpn": "BPN del sitio",
        "siteAreaOfApplication": "Área de aplicación del sitio"
      },
      "tooltips": {
        "basicInfo": "Un certificado de socio comercial describe un certificado (por ejemplo ISO9001, IATF-16949) a través de un documento de certificado de un socio comercial Catena-X",
        "businessPartnerNumber": "El Número de Socio Comercial (BPN) de la entidad jurídica certificada (sobre la cual se emite el certificado).",
        "registrationNumber": "Número de registro del certificado según se define en el certificado",
        "certificateType": "Tipo de certificado según se define en el documento, los tipos válidos están registrados en el controlador de metadatos BPN",
        "certificateVersion": "Versión del certificado según se define en el documento, usualmente la versión específica de un estándar de certificación",
        "issuerName": "Nombre del emisor, es decir, la autoridad certificadora.",
        "issuerBpn": "El Número de Socio Comercial (BPN) del emisor.",
        "validFrom": "Fecha de validez desde, según se define en el certificado.",
        "validUntil": "Válido hasta la fecha definida en el certificado. Si el certificado nunca expira, el valor esperado es 9999-12-31",
        "trustLevel": "El nivel de confianza del certificado dado - none, low, high, trusted",
        "uploaderBpn": "El Número de Socio Comercial (BPN) del socio comercial que proporcionó originalmente los datos o documento del certificado.",
        "validatorBpn": "El Número de Socio Comercial (BPN) del proveedor de servicios de datos que validó el certificado dado",
        "validatorName": "El nombre opcional del proveedor de servicios de datos que validó el certificado dado",
        "areaOfApplication": "Detalles sobre qué áreas / tipos de aplicación para los cuales un certificado es válido para una empresa y/o sitio.",
        "siteBpn": "El Número de Socio Comercial (BPNS o BPNA) de un sitio incluido",
        "siteAreaOfApplication": "Detalles sobre qué áreas / tipos de aplicación para los cuales un certificado es válido para una empresa y/o sitio."
      }
    }
  },
  "common": {
    "start": "Comenzar",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico",
    "phoneNumber": "Número de teléfono",
    "contactPerson": "Persona de contacto",
    "welcome": "Bienvenido",
    "street": "Calle",
    "city": "Ciudad",
    "country": "País",
    "postCode": "Código postal",
    "number": "Número",
    "next": "Siguiente",
    "prev": "Atrás",
    "alreadyAccount": "¿Ya tienes una cuenta?",
    "login": "Iniciar sesión",
    "loginNow": "Inicia sesión ahora",
    "register": "Registrarse",
    "home": "Inicio",
    "submit": "Enviar",
    "attention": "Atención",
    "desc": "Descripción",
    "website": "Sitio web",
    "contact": "Contacto",
    "details": "Detalles",
    "plan": "Plan",
    "table": "Tabla",
    "grid": "Cuadrícula",
    "listView": "Vista de lista",
    "gridView": "Vista de cuadrícula",
    "firstPage": "A la primera página",
    "previousPage": "A la página anterior",
    "nextPage": "A la página siguiente",
    "lastPage": "A la última página",
    "paginationUnknownButton": "Tipo de botón de paginación desconocido",
    "download": "Descargar",
    "delete": "Eliminar",
    "edit": "Editar",
    "information": "Información",
    "organization": "Organización",
    "cancel": "Cancelar",
    "save": "Guardar",
    "upload": "Subir",
    "link": "Enlace",
    "view": "Ver",
    "search": "Buscar",
    "searchTerm": "Buscar",
    "selectOption": "Selecciona una opción",
    "sortBy": "Ordenar por",
    "dataspace": "Espacio de datos",
    "select": "Seleccionar",
    "date": "Fecha",
    "title": "Título",
    "back": "Atrás",
    "startTyping": "Empieza a escribir",
    "useCases": "Casos de uso",
    "done": "Hecho",
    "enterValue": "Introduce un valor",
    "selectValue": "Selecciona un valor",
    "selectDate": "Selecciona una fecha",
    "refresh": "Actualizar",
    "searchByName": "Buscar por nombre",
    "close": "Cerrar",
    "copyToClipboard": "¡Copiado al portapapeles!",
    "enterKeyName": "Introduce el nombre de la clave",
    "fileDownloadSuccess": "Archivo descargado con éxito",
    "fileDownloadError": "Error al descargar el archivo",
    "certificate": "Certificado",
    "manageConnections": "Gestionar conexiones",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "connectionDetails": "{type} Detalles de conexión",
    "hide": "Esconder",
    "unpublish": "Inútil",
    "clear": "Claro"
  },
  "genericError": "¡Oh, algo salió mal! Por favor, inténtalo de nuevo.",
  "validation": {
    "fieldRequired": "{field} es obligatorio.",
    "fieldNumeric": "El campo {field} solo puede contener números.",
    "fieldAlpha": "El campo {field} solo puede contener letras, _ y -.",
    "fieldAlphanumeric": "El campo {field} solo puede contener letras, números, _ y -.",
    "fieldNumericDash": "El campo {field} solo puede contener números y -.",
    "fieldHouseNumber": "El campo {field} solo puede contener números, letras y los caracteres - y /.",
    "fieldPhoneNumber": "El campo {field} solo puede contener números y -. Debe comenzar con + o 00.",
    "fieldAlphaDash": "El campo {field} solo puede contener letras y -.",
    "exceptHTMLTagBrackets": "El campo {field} no debe contener los siguientes caracteres: ^<>",
    "isMaxLength": "supera la longitud máxima de 10 caracteres.",
    "emailFormat": "El formato del correo electrónico es incorrecto",
    "fileSizeError": "El tamaño del archivo es mayor que {size} MB.",
    "csvFileSizeError": "Este archivo es demasiado grande. Puedes subir archivos de hasta {size} MB.",
    "csvFileExtensionError": "Solo se permiten archivos con extensión csv.",
    "csvFileIsEmptyError": "Este archivo está vacío. Debes subir al menos un archivo de {size} KB.",
    "csvFileFormatError": "El archivo no coincide con el formato esperado. Por favor, usa la plantilla proporcionada e inténtalo de nuevo.",
    "uploadFails": "la carga falló",
    "fileExtensionError": "La extensión del archivo no es adecuada",
    "fileIsMalwareInfectedError": "Este archivo parece contener malware. Por razones de seguridad, este archivo no puede ser subido. Por favor, revisa tu archivo nuevamente",
    "customValidation": "El {field} tiene un formato incorrecto.",
    "selectCountryFirst": "Por favor, selecciona primero el nombre del país",
    "validationPostCodeCaseDE": "El campo tiene un formato incorrecto. Debe contener 5 dígitos, por ejemplo, 53113",
    "validationAlphanumericCase": "El campo solo puede contener caracteres alfanuméricos, guiones y guiones bajos. El valor debe comenzar con un carácter alfanumérico.",
    "validationNumericDashCase": "El campo solo puede contener números y -.",
    "url": "Por favor, introduce una URL válida",
    "required": "Este campo es obligatorio",
    "password": {
      "passwordStrength": "Fortaleza de la contraseña",
      "weak": "Débil",
      "average": "Media",
      "strong": "Fuerte",
      "passwordValidationMoreChar": "{count} o más caracteres",
      "passwordUpperAndLowerChar": "Caracteres en mayúsculas y minúsculas",
      "passwordAtLeastNumber": "Al menos un número",
      "passwordAtLeastSpecialChar": "Al menos un carácter especial (excepto <>&\"`[])",
      "passwordDiffFromPrev": "Difiere de tus contraseñas anteriores"
    }
  },
  "footer": {
    "tagLine": "Impulsando un mayor rendimiento",
    "imprint": "Aviso legal",
    "imprintShort": "Aviso legal",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "Contacto",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "Términos y condiciones",
    "privacy": "Política de privacidad",
    "privacyShort": "Privacidad",
    "telekom": "T-Systems International GmbH. Todos los derechos reservados.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub - Solo para clientes empresariales",
    "brandedNote": "Desarrollado por Telekom Data Intelligence Hub",
    "help": "Ayuda",
    "cookieSettings": "Configuración de cookies",
    "cookieSettingsShort": "Cookies",
    "life": "La vida es para compartir"
  },
  "cookieSettings": {
    "collapsedTitle": "Configuración de privacidad",
    "collapsedText": "Este sitio web utiliza cookies y tecnologías similares. Son pequeños archivos de texto que se almacenan y leen en tu ordenador. Al hacer clic en '{0}', aceptas el procesamiento, la creación de perfiles de usuario individuales en sitios web y socios, y la transferencia de tus datos a terceros, algunos de los cuales procesan tus datos en países fuera de la Unión Europea (GDPR Art. 49). Los detalles se pueden encontrar en la sección 2 de la {1}. Los datos se utilizan para análisis, retargeting y para mostrar contenido y publicidad personalizada en sitios de Telekom y de terceros. Más información, incluyendo información sobre el procesamiento de datos por parte de terceros y la posibilidad de revocación, se puede encontrar en la configuración y en nuestra información de privacidad. Aquí puedes {2} solo con las herramientas necesarias.",
    "extendedTitle": "Configuración de privacidad",
    "extendedText": "Para ofrecerte una experiencia web óptima, utilizamos cookies. Estas incluyen cookies para el funcionamiento y la optimización del sitio, así como para servicios como chat de texto o vídeo y para publicidad basada en tu comportamiento de uso en línea. Esto nos permite, por ejemplo, detectar si visitas nuestras páginas repetidamente desde el mismo dispositivo. Nos gustaría darte la opción de elegir qué cookies permites:",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "información de privacidad",
    "policyLinkText": "Información de privacidad",
    "rejectLinkText": "continuar",
    "acceptButton": "Aceptar todo",
    "saveButton": "Guardar configuración",
    "settingsButton": "Cambiar configuración",
    "showMore": "Mostrar más",
    "showLess": "Mostrar menos",
    "categoryTitleEssential": "Cookies necesarias",
    "categoryTitleAnalytics": "Cookies analíticas",
    "categoryTitleMarketing": "Cookies de marketing",
    "categoryTitleThirdParty": "Servicios de otras empresas (proveedores independientes)",
    "categoryTextEssential": "Estas cookies son necesarias para que puedas navegar por los sitios web y utilizar funciones clave. Soportan funciones básicas, como el procesamiento de pedidos en la tienda online y el acceso a áreas seguras de la página web. También sirven para realizar un análisis anónimo de los patrones de usuario, que utilizamos para desarrollar y mejorar continuamente nuestras páginas web para ti.",
    "categoryTextAnalytics": "Estas cookies nos ayudan a mejorar nuestra comprensión del comportamiento del usuario. Las cookies de análisis permiten la recopilación de datos de uso e identificación por parte del proveedor original o de terceros en perfiles de uso seudónimos. Utilizamos cookies de análisis, por ejemplo, para determinar el número de visitantes individuales a una página web o servicio, recopilar datos estadísticos sobre el rendimiento de nuestros productos y analizar los patrones de uso e interacciones de los visitantes sobre la base de información anónima y seudónima. Esta información no puede ser rastreada hasta una persona.",
    "categoryTextMarketing": "Estas cookies y tecnologías similares se utilizan para permitir la visualización de contenido de marketing personalizado y, por lo tanto, relevante. Las cookies de marketing se utilizan para mostrar contenido publicitario interesante y para medir la efectividad de nuestras campañas. Esto ocurre no solo en los sitios web de Telekom, sino también en otros sitios de socios publicitarios (proveedores externos). Esto también se llama retargeting. Se utiliza para crear perfiles de contenido o anuncios seudónimos, colocar publicidad relevante en otros sitios web y obtener información sobre los grupos objetivo que han visto los anuncios y el contenido. Esta información no puede ser rastreada hasta una persona. Las herramientas de marketing y retargeting nos ayudan a mostrarte contenido publicitario que puede ser relevante para ti. Al suprimir las cookies de marketing, seguirás viendo la misma cantidad de publicidad, pero puede que sea menos relevante para ti.",
    "categoryTextThirdParty": "Los sitios web de Telekom incluyen enlaces a proveedores de servicios externos, que prestan sus servicios bajo su propia responsabilidad. Cuando visitas las páginas web de Telekom, las cookies o tecnologías similares registran datos y los envían a terceros, en parte para fines propios de Telekom. El alcance, propósito y base legal sobre la que se lleva a cabo el procesamiento posterior para los propios fines del tercero se pueden encontrar en la información de privacidad de datos del tercero. La información sobre los proveedores independientes se puede encontrar en la información de privacidad de datos."
  },
  "messages": {
    "noDataAvailable": "No hay datos disponibles",
    "noMatchFound": "No se encontró coincidencia",
    "maximumFileSize": "Tamaño máximo de archivo",
    "suitableFileFormats": "Formatos de archivo adecuados",
    "loading": "Cargando...",
    "dragDropText": "o arrástralo y suéltalo aquí",
    "noConnectors": "¡No se encontraron conectores!",
    "comingSoon": "Próximamente"
  },
  "pageNotFound": {
    "title": "¡Ups! Parece que la página que buscas aún no existe.",
    "subtitle": "Mientras tanto, consulta nuestros otros recursos, ¡pueden ser útiles para ti!"
  },
  "helpResources": {
    "needHelp": "¿Necesitas ayuda para encontrar el plan adecuado, más información o tienes preguntas técnicas?",
    "developerDoc": "Documentación para integradores",
    "developerDocDesc": "Obtén la documentación de la API para comenzar",
    "example": "Ejemplo",
    "tutorials": "Tutoriales",
    "exampleDescription": "Encuentra casos de uso y demostraciones relevantes para tu sector industrial",
    "FAQ": "Preguntas frecuentes",
    "FAQDescription": "Encuentra respuestas comunes desde facturación hasta privacidad",
    "browse": "Explorar",
    "demos": "Demostraciones",
    "demosDescription": "Encuentra casos de uso y demostraciones relevantes para tu sector industrial",
    "glossary": "Glosario",
    "glossaryDescription": "Encuentra los términos y definiciones relacionados con Data Intelligence Hub, IDSA, Catena-X, Gaia-X y más.",
    "contactUs": "Esta función no está soportada en tu suscripción actual. Por favor, contáctanos para actualizar."
  },
  "feedbackCard": {
    "title": "¿Necesitas más ayuda?",
    "contactUs": "Contáctanos"
  },
  "error": {
    "pageNotFound": "Página no encontrada (404)",
    "somethingWrong": "¡Algo salió mal!",
    "propertyNotFound": "Propiedad no encontrada",
    "uniquePropertyName": "El nombre de la propiedad debe ser único",
    "dctTypeNotFound": "dct:type no encontrado"
  },
  "helpWidget": {
    "askSupport": "Solicitar soporte",
    "chatboxTitle": "Chat de ayuda",
    "chatboxSubtitle": "Soporte de Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Hola, bienvenido al canal de soporte de Telekom Data Intelligence Hub. Por favor, selecciona una opción a continuación."
    },
    "whatCanWeHelpWith": "¿En qué podemos ayudarte hoy?",
    "suggestedAnswers": {
      "knowledgeBase": "Base de conocimientos, documentación y preguntas frecuentes",
      "contactSupport": "Contactar soporte",
      "contactSales": "Contactar ventas"
    }
  },
  "pcfExchange": {
    "title": "Intercambio PCF",
    "description": "Bienvenido a la solución de intercambio de Product Carbon Footprint (PCF) de extremo a extremo fácil de usar en Catena-X.",
    "recentRequests": "Solicitudes recientes de datos PCF",
    "viewAllRequests": "Ver todas las solicitudes",
    "requestPcf": "Solicitar PCF",
    "termCheck": "Al enviar la solicitud, entiendo que el contrato se negociará sobre la oferta de datos según las políticas establecidas por el proveedor de datos.",
    "pcfSuccess": "¡PCF solicitado con éxito!",
    "landing": {
      "pcfTitle": "Crear oferta PCF",
      "pcfDesc": "Crea y comparte los datos PCF con participantes en la red Catena-X.",
      "discoverTitle": "Descubre y solicita datos PCF",
      "discoverDesc": "Busca fácilmente datos PCF en la red Catena-X o solicita los datos PCF a tus socios en pocos pasos.",
      "pcfReqTitle": "Solicitudes de datos PCF",
      "pcfReqDesc": "Gestiona eficientemente las solicitudes de datos PCF de tus socios en la red Catena-X.",
      "pcfCalcTitle": "Calculadora PCF",
      "pcfCalcDesc": "Calcula los valores PCF y conéctate a tus aplicaciones o escenarios de intercambio de datos PCF sin problemas.",
      "pcfHistoryTitle": "Historial de intercambio de datos PCF",
      "pcfHistoryDesc": "Obtén transparencia sobre tu historial de intercambio de datos PCF en la red Catena-X y tus socios.",
      "documentation": "Aprende sobre el intercambio de datos PCF",
      "howTo": {
        "description": "Comparte, descubre y gestiona las ofertas de datos de la huella de carbono del producto (PCF) dentro de Catena-X.",
        "doc": "¿Quieres saber más sobre Connect & Integrate? Enlace a la documentación: "
      }
    },
    "requests": {
      "pcfRequests": "Solicitudes de datos PCF",
      "reqDesc": "Utiliza el área para gestionar tus solicitudes de datos PCF de socios.",
      "productId": "ID de producto*",
      "bpn": "BPN*",
      "message": "Mensaje",
      "howTo": {
        "title": "¿Quieres saber más sobre cómo funciona la gestión de solicitudes de datos PCF?",
        "description": "Utiliza esta sección para aprobar o rechazar la solicitud de datos PCF de tus socios. Además, consulta los estados de los intercambios de datos PCF y obtén total transparencia en tu cadena de datos PCF.",
        "doc": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?"
      }
    },
    "responses": {
      "howTo": {
        "description": " Descubre el catálogo de ofertas de datos de otras empresas miembros de Catena-X. Puedes buscar, seleccionar y suscribirte a una oferta de datos. Puedes buscar ofertas de datos usando el nombre de la empresa o con el ID de pieza del fabricante o con una combinación de ambos."
      }
    },
    "view": {
      "title": "Ver detalles de PCF"
    }
  },
  "publicationTemplates": {
    "title": "Mis plantillas de publicación",
    "deletedTemplates": "Mis plantillas eliminadas",
    "showDeletedTemplates": "Mostrar plantillas eliminadas",
    "hideDeletedTemplates": "Mostrar plantillas activas",
    "newTemplate": "Nueva plantilla",
    "create": {
      "title": "Crear plantilla de publicación",
      "edit": "Editar plantilla de publicación",
      "templateName": "Nombre de la plantilla",
      "templateType": "Plantilla de {type}",
      "create": "Crear",
      "update": "Actualizar",
      "name": "Nombre",
      "createdAt": "Creado en",
      "modifiedAt": "Modificado en",
      "country": "País",
      "accessPolicyId": "Política de acceso",
      "usagePolicyId": "Política de uso",
      "id": "ID",
      "createdBy": "Creado por",
      "modifiedBy": "Modificado por",
      "isEnabled": "Está habilitado",
      "targetCompany": "Empresa objetivo",
      "targetConnectors": "Conectores objetivo",
      "selectCountry": "Selecciona un país",
      "templateDetails": "Detalles de la plantilla de publicación",
      "assetsCriteria": "Criterios de selección de activos",
      "connectorDetails": "Detalles del conector"
    },
    "delete": {
      "title": "Eliminar plantilla de publicación",
      "description": "¿Estás seguro de que deseas eliminar esta plantilla?",
      "button": "Eliminar"
    }
  },
  "contracts": {
    "title": "Detalles de acuerdos de contrato",
    "provider": {
      "description": "Esta es una visión general de los acuerdos de contrato que tu organización tiene con otros participantes del espacio de datos.",
      "howItWorks": {
        "description": "Aquí puedes encontrar todos tus acuerdos de datos suscritos o negociados en varios espacios de datos. Puedes filtrar los resultados para un conector en particular o simplemente buscar con un ID de acuerdo de contrato o ID de activo. También puedes ordenar la lista para ver los acuerdos de datos según tus necesidades. Además, puedes seleccionar las ofertas de datos y exportarlas localmente si lo deseas.",
        "subtitle": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?"
      },
      "details": {
        "title": "Detalles de acuerdos de contrato proporcionados",
        "description": "Descripción",
        "content": "Contenido",
        "agreementDetails": "Detalles del acuerdo",
        "assetDetails": "Detalles del activo",
        "usagePolicy": "Política de uso"
      }
    },
    "consumer": {
      "description": "Esta es una visión general de los acuerdos de contrato que tu organización tiene para ofertas de datos de otros participantes del espacio de datos",
      "downloadData": "Descargar datos",
      "downloadAgreement": "Descargar acuerdo",
      "reinitiate": "Iniciar transferencia y descargar datos",
      "error": {
        "heading": "¡Lo sentimos! Parece que ya has negociado este contrato.",
        "body": "No puedes volver a negociar un contrato ya negociado. Puedes encontrar los detalles del contrato a continuación y también puedes descargar este acuerdo y suscribirte a los datos."
      },
      "details": {
        "title": "Detalles de acuerdos de contrato consumidos"
      },
      "howItWorks": {
        "description": "Aquí puedes encontrar todos tus acuerdos de datos suscritos o negociados en varios espacios de datos. Puedes filtrar los resultados para un conector en particular o simplemente buscar con un ID de acuerdo de contrato o ID de activo. También puedes ordenar la lista para ver los acuerdos de datos según tus necesidades. Además, puedes seleccionar las ofertas de datos y exportarlas localmente si lo deseas.",
        "subtitle": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?"
      }
    }
  },
  "provider": {
    "provider": "Proveedor",
    "assets": {
      "title": "Mis activos",
      "offeredBy": "Ofrecido por:",
      "offers": "Ofertas",
      "created": "Creado",
      "modifiedAt": "Modificado en",
      "noResultsFound": "No se encontraron activos",
      "success": "Activo creado con éxito",
      "updateSuccess": "Activo actualizado con éxito",
      "buttons": {
        "createOffer": "Crear oferta",
        "details": "Ver detalles",
        "delete": "Eliminar activo",
        "create": "Crear activo",
        "close": "Cerrar",
        "edit": "Editar activo",
        "update": "Actualizar activo",
        "showDeleted": "Mostrar activos eliminados",
        "hideDeleted": "Ocultar activos eliminados",
        "restore": "Restaurar activo",
        "save": "Guardar",
        "add": "Agregar par clave-valor",
        "addJson": "Agregar objeto json",
        "editJson": "Editar objeto json",
        "saveJson": "Guardar JSON",
        "advanceAddition": "Adición avanzada",
        "unpublish": "Activo no publicado",
        "showAssets": "Mostrar activos"
      },
      "detailsDialog": {
        "title": "Detalles del activo"
      },
      "createDialog": {
        "title": {
          "general": "Crear nuevo activo",
          "edit": "Editar activo",
          "addProperties": "Agregar propiedades",
          "advance": "Adición avanzada de propiedades"
        },
        "publicProps": "Propiedades públicas",
        "privateProps": "Propiedades privadas",
        "dataAddress": "Dirección de datos",
        "dataSources": "Fuente de datos",
        "dataDestination": "Destino de datos",
        "json": {
          "fields": "Campos Json",
          "editor": "Editor de propiedades personalizadas",
          "formatted": "Visor de propiedades personalizadas",
          "error": "JSON inválido:"
        },
        "connectionTypeLabel": {
          "http": "Introducir la URL",
          "s3": "Introducir el nombre del objeto",
          "azure": "Introducir el nombre del blob",
          "sftp": "Introducir el nombre del archivo"
        },
        "fields": {
          "name": "Nombre",
          "namePlaceholder": "Introduce el nombre de la oferta",
          "id": "ID",
          "description": "Descripción",
          "contenttype": "Tipo de contenido",
          "contenttypePlaceholder": "Introduce el tipo de contenido",
          "contentType": "Tipo de contenido",
          "contentTypePlaceholder": "Introduce el tipo de contenido",
          "version": "Versión",
          "keywords": "Palabras clave",
          "language": "Idioma",
          "languagePlaceholder": "Selecciona el idioma",
          "semanticId": "ID semántico",
          "semanticIdPlaceholder": "Por favor, introduce el ID semántico",
          "dct:type": "dct:type",
          "dct:typePlaceholder": "Elige un tipo dct",
          "keywordsPlaceholder": "Agregar palabras clave",
          "descriptionPlaceholder": "Escribe la descripción de la oferta",
          "versionPlaceholder": "Número de versión",
          "dataType": "Tipo de dirección de datos",
          "dataTypePlaceholder": "Selecciona el tipo de dirección de datos",
          "dataAddressUrl": "URL del activo",
          "dataAddressUrlPlaceholder": "Introduce la URL del activo",
          "targetCompany": "Empresa objetivo",
          "targetCompanyPlaceholder": "Introduce una empresa objetivo",
          "country": "País",
          "countryPlaceholder": "Introduce un país",
          "key": "Clave",
          "keyPlaceholder": "Introduce la clave",
          "value": "Valor",
          "valuePlaceholder": "Introduce el valor",
          "assetType": "Tipo de activo",
          "assetTypePlaceholder": "Introduce el tipo de activo"
        },
        "validation": {
          "name": "Por favor, introduce un nombre",
          "assetType": "Por favor, selecciona un tipo de activo",
          "contentType": "Por favor, introduce un tipo de contenido válido",
          "dataType": "Por favor, selecciona un tipo de datos válido",
          "targetCompany": "Por favor, introduce una empresa objetivo válida",
          "country": "Por favor, introduce un país válido"
        }
      },
      "tags": {
        "restricted": "Acceso restringido",
        "unrestricted": "Sin restricciones"
      },
      "search": {
        "title": "Filtros de búsqueda",
        "helperText": "Busca por nombre de activo, fecha de creación o tipo",
        "filters": {
          "byName": "Nombre del activo",
          "byType": "Tipo de activo",
          "byDate": "Fecha de modificación"
        }
      },
      "delete": {
        "title": "Eliminar activo",
        "description": "¿Estás seguro de que deseas eliminar este activo?"
      },
      "unpublish": {
        "title": "Activo no publicado",
        "description": "¿Estás seguro de que quieres no publicar este activo?"
      }
    },
    "fileUploadTerms": "Entiendo y confirmo que he completado correctamente toda la información requerida y T-Systems no es responsable en caso de información incorrecta y rechazo de la oferta.",
    "fileUploadInfo": "T-Systems no verifica la validez de la información de metadatos completada aquí. Por favor, asegúrate de haber completado la información correcta y completa.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Entrada única",
    "bulkEntries": "Entradas masivas"
  },
  "home": {
    "title": "Conectar e integrar"
  },
  "gettingStarted": {
    "title": "¿Necesitas ayuda para comenzar?",
    "openWizard": "Abrir asistente",
    "yourDataOffering": "Tu oferta de datos",
    "yourAssets": "Activos",
    "yourPolicies": "Mis políticas",
    "preconfiguredCatalogue": "Catálogo preconfigurado",
    "contractAgreements": "Acuerdos de contrato",
    "incomingAgreements": "Acuerdos entrantes",
    "outgoingAgreements": "Acuerdos salientes",
    "connectors": "Tus conectores",
    "providedAgreements": "Acuerdos de contrato proporcionados",
    "consumedAgreements": "Acuerdos de contrato consumidos"
  },
  "yourConnection": {
    "title": "Tus conectores",
    "viewAllConnection": "Ver todos los conectores",
    "help": "Ayuda",
    "documentation": "Conoce tu Connect & Integrate",
    "gettingStarted": "Guía de inicio",
    "noUseCases": "No hay casos de uso disponibles"
  },
  "wizardSelectionPopup": {
    "whatToLike": "¿Qué te gustaría hacer hoy?",
    "prepare": "Preparar",
    "govern": "Gobernar",
    "provide": "Proveer",
    "consume": "Consumir",
    "howToProvide": "¿Cómo te gustaría proveer datos hoy?",
    "manual": "Manual",
    "automated": "Automatizado vía API",
    "selectUseCases": "Selecciona tus casos de uso",
    "selectSingleUseCase": "Selecciona tu caso de uso",
    "selectDigitalTwin": "Selecciona tu tipo de gemelo digital",
    "back": "Atrás",
    "next": "Siguiente",
    "publish": "Entiendo los requisitos del marco del espacio de datos y acepto publicar la oferta de datos en el espacio de datos en nombre de mi organización."
  },
  "createOffer": {
    "title": {
      "standard": "Crear oferta de datos",
      "pcf": "Crear oferta de datos PCF",
      "certificate": "Crear oferta de certificado"
    },
    "publish": "Publicar",
    "legalConfirmation": "Entiendo los requisitos del marco del espacio de datos y acepto publicar la oferta de datos en el espacio de datos en nombre de mi organización.",
    "wizard": {
      "provisionAsset": "Proveer activo",
      "dataUpload": "Selección de datos",
      "attachPolicy": "Adjuntar política",
      "publishDataOffer": "Publicar oferta de datos"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "¿Para qué submodelo te gustaría crear una oferta de datos?",
      "selectSubmodel": "Selecciona submodelo",
      "selectUsecase": "Selecciona un caso de uso",
      "selectDigitalTwinType": "Selecciona un tipo de gemelo digital",
      "whichTypeToSelect": "¿Qué tipo debo seleccionar?",
      "generalInformation": "Información general",
      "name": "Nombre",
      "id": "ID",
      "description": "Descripción",
      "contentType": "Tipo de contenido",
      "version": "Versión",
      "keywords": "Palabras clave",
      "language": "Idioma",
      "location": {
        "title": "Ubicación y direccionamiento",
        "text": "Por favor, introduce los detalles de tu activo"
      },
      "username": "Usuario",
      "password": "Contraseña",
      "assetUrl": "URL del activo",
      "assetUrlPlaceHolder": "Por favor, introduce la URL de tu activo",
      "clientId": "ID de cliente",
      "clientSecret": "Secreto de cliente",
      "tokenUrl": "URL del token",
      "tokenUrlPlaceHolder": "Por favor, introduce la URL de tu token",
      "provideAssets": "Proveer activo",
      "selectConnectorLabel": "Selecciona a qué conector(es) te gustaría compartir tus datos",
      "selectConnectorPlaceholder": "Selecciona un conector",
      "selectRestApiType": "Selecciona tipo de REST-API",
      "selectedAuthMethod": "Método de autenticación"
    },
    "dataUpload": {
      "selectedDataModel": "Selecciona tus datos",
      "csvUpload": {
        "title": "Archivo CSV",
        "description": "Arrastra y suelta tus archivos aquí",
        "uploadFile": "Seleccionar archivo",
        "uploadFileDescription": "Prepara y sube el archivo que deseas intercambiar. Puedes descargar el archivo de muestra para ayudarte a comenzar con el formato requerido para Catena-X.",
        "uploadFileDescriptionNote1": "Descarga el archivo de plantilla desde el siguiente enlace",
        "uploadFileDescriptionNote2": "Rellena el archivo proporcionado con los detalles de tus socios",
        "uploadFileDescriptionNote3": "Sube el archivo en el área proporcionada",
        "partnerValidationNote": "Si deseas saber más sobre la validación de socios, por favor",
        "clickHere": "haz clic aquí",
        "downloadTemplate": "Descargar plantilla",
        "downloadSampleCsv": "Descargar muestra csv",
        "supportedFileTypes": "Tipos de archivos compatibles:"
      },
      "jsonUpload": {
        "title": "json",
        "description": "Escribe tu propio código json"
      },
      "tableUpload": {
        "title": "Tabla",
        "description": "Proporciona entradas de tabla personalizadas",
        "add": "Agregar"
      },
      "fileUpload": {
        "title": "Subir archivo",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Almacenamiento de objetos",
        "description": "AWS, Azure, OTC o GCP"
      },
      "sftp": {
        "title": "Servidor SFTP",
        "description": "transferencia vía SFTP"
      },
      "apiUpload": {
        "title": "REST API",
        "description": "transferencia vía API",
        "authAndIdentiTitle": "Autenticación e identificación",
        "authAndIdentiDesc": "Por favor, introduce los detalles de autenticación de tu sistema de destino",
        "selectApiType": "Selecciona tipo de REST-API",
        "locationAndAddrTitle": "Ubicación y direccionamiento",
        "locationAndAddrDesc": "Por favor, introduce los detalles de tu activo",
        "assetUrl": "URL del activo",
        "username": "Usuario",
        "password": "Contraseña",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente"
      }
    },
    "fileUpload": {
      "title": "Arrastra y suelta tu archivo aquí",
      "btnText": "Seleccionar archivo"
    },
    "attachPolicy": {
      "title": "Adjunta una política a esta oferta de datos",
      "createPolicy": "Crear nueva política",
      "bpnFieldTitle": "¿Con quién deseas intercambiar tus datos?",
      "howItWork": {
        "title": "¿Cómo funciona?",
        "description": "Preconfiguramos las políticas según el acuerdo marco de casos de uso de Catena-X. El acceso a tus datos solo se permitirá para los Números de Socio Comercial proporcionados.",
        "knowMore": "¿Quieres saber más sobre las políticas?",
        "documentation": "Documentación"
      },
      "accessPolicyTableText": "Adjunta una política de acceso a esta oferta de datos",
      "usagePolicyTableText": " Adjunta una política de uso a esta oferta de datos",
      "heading": {
        "title": "Adjunta políticas existentes o crea nuevas",
        "description": "Por favor, adjunta tanto la política de acceso como la de uso de las tablas a continuación para finalizar la publicación de la oferta de datos. También puedes buscar políticas por nombre o crear una nueva política si aún no tienes la deseada."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Detalles de la oferta de datos",
      "generalInformation": "Información general",
      "attribute": "Atributo",
      "value": "Valor",
      "knowMore": "Saber más sobre tu oferta de datos",
      "attachedDataAssets": "Elementos adjuntos",
      "attachedPolicies": "Políticas adjuntas",
      "allowPolicyPublish": "Permito la publicación de la política",
      "publish": "Publicar",
      "verifiedLegalEntity": "Entidad legal verificada por",
      "dataOfferCreatedBy": "Oferta de datos creada por: ",
      "contactOrgAdmin": "Contactar al administrador de la organización",
      "help": "Ayuda",
      "attachedDataAsset": "Activo de datos adjunto",
      "attachedAccessPolicy": "Política de acceso adjunta",
      "attachedUsagePolicy": "Política de uso adjunta",
      "publishedConnectors": "Conectores a los que se publicará esta oferta",
      "knowMoreConnector": "Saber más sobre tus conectores",
      "knowMorePolicies": "Saber más sobre tus políticas",
      "knowMoreDataAssets": "Saber más sobre tus activos de datos",
      "knowMoreDataOffers": "Saber más sobre tu oferta de datos",
      "publishCheckboxLabel": "Yo, en nombre de mi organización, acepto publicar la oferta de datos y los activos en el espacio de datos. Confirmo el uso de las políticas asociadas para gobernar el espacio de datos y las políticas asociadas y seguiré el marco del espacio de datos para cualquier operación sobre la oferta y los activos una vez publicados."
    },
    "result": {
      "success": {
        "title": "Solicitud exitosa.",
        "description": "¡El proceso de publicación del activo ha comenzado! El id del trabajo es {id}"
      }
    },
    "success": {
      "title": "Tu oferta de datos ya está publicada",
      "description": "Tu oferta de datos ya está publicada, haz clic en lo siguiente para los próximos pasos",
      "createOffer": "Crear otra oferta de datos",
      "createOfferButton": "Crear",
      "goToHome": "Ir al inicio",
      "goToHomeButton": "Ir al inicio",
      "uploadHistory": "Consulta tu historial de cargas"
    }
  },
  "policy": {
    "newPolicy": "Nueva política",
    "showDeletedPolicies": "Mostrar políticas eliminadas",
    "myDeletedPolicies": "Mis políticas eliminadas",
    "hideDeletedPolicies": "Mostrar políticas activas",
    "restoreAsset": "Restaurar",
    "publishDeletion": "Publicar eliminación",
    "create": {
      "title": "Crear nueva política",
      "edit": "Editar política",
      "policyName": "Nombre de la política",
      "policyType": "Política de {type}",
      "accessPolicy": "Política de acceso",
      "usagePolicy": "Política de uso",
      "create": "Crear y guardar",
      "update": "Actualizar"
    },
    "delete": {
      "title": "Eliminar política",
      "description": "¿Estás seguro de que deseas eliminar esta política?",
      "button": "Eliminar"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Número de socio comercial",
        "description": "La restricción del número de socios comerciales se puede utilizar para definir qué socios comerciales exactos (según BPNL) pueden ver o negociar la oferta de datos respectiva. "
      },
      "BusinessPartnerGroup": {
        "title": "Grupo de socios comerciales",
        "description": "La restricción del grupo de socios comerciales se puede utilizar para definir qué socios comerciales exactos (según BPNL) pueden ver o negociar la oferta de datos respectiva. "
      },
      "Membership": {
        "title": "Afiliación",
        "description": "La credencial de membresía se puede utilizar para garantizar que solo los miembros de CX puedan ver o negociar la oferta de datos respectiva."
      },
      "ContractReference": {
        "title": "Referencia del contrato",
        "description": "La restricción de referencia del contrato se puede utilizar para definir bajo qué detalles del contrato bilateral se comparten los datos. "
      },
      "Dismantler": {
        "title": "Desmantelador",
        "description": "Las empresas que poseen la credencial son empresas certificadas como desmanteladoras.",
        "allowedBrands": {
          "title": "Marcas permitidas del desmantelador",
          "description": "Función de la empresa que define un desmantelador. Las empresas que poseen la credencial son empresas certificadas como desmanteladoras."
        }
      },
      "UsagePurpose": {
        "title": "Propósito de uso",
        "description": "Propósito de uso"
      },
      "FrameworkAgreement": {
        "title": "Acuerdo Marco",
        "description": "Con la credencial FrameworkAgreement, solo aquellos participantes que hayan firmado el acuerdo marco respectivo (general o mediante una versión específica) pueden ver o negociar la oferta de datos respectiva. "
      },
      "Duration": {
        "title": "Duración",
        "description": "Duración del uso de datos desde la fecha de firma."
      },
      "inForceDate": {
        "title": "Rango de fechas fijas",
        "description": "Marco de tiempo de fecha fija para el uso de datos."
      },
      "connector": {
        "title": "Restricción del conector",
        "description": "Las empresas que poseen los conectores para utilizarlos tienen restricciones."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Número de socio comercial",
      "tx:BusinessPartnerGroup": "Grupo de socios comerciales",
      "cx-policy:Membership": "Afiliación",
      "cx-policy:ContractReference": "Referencia del contrato",
      "cx-policy:Dismantler.allowedBrands": "Marcas permitidas del desmantelador",
      "cx-policy:Dismantler": {},
      "cx-policy:UsagePurpose": "Propósito de uso",
      "cx-policy:FrameworkAgreement": "Acuerdo Marco",
      "duration": "Duración",
      "unit": "Unidad",
      "fromdate": "Desde la fecha",
      "todate": "Hasta la fecha",
      "connector": "Conector"
    }
  },
  "jobs": {
    "jobs": "Trabajos",
    "id": "Id",
    "name": "Nombre",
    "startedAt": "Iniciado en",
    "status": "Estado",
    "duration": "Duración",
    "action": "Acciones",
    "jobDetails": "Detalles del proceso",
    "reload": "Recargar",
    "noDetailsAvailable": "No hay más detalles disponibles para este trabajo",
    "retry": "Reintentar"
  },
  "search-offer": {
    "pageTitle": "Buscar ofertas de datos",
    "pcfTitle": "Buscar ofertas de datos PCF",
    "certificateTitle": "Buscar ofertas de certificados de socios comerciales",
    "filter": {
      "bpnSearch": "Buscar por tu número de socio comercial o nombre de empresa",
      "bpnSearchNote": "Encuentra las ofertas de datos buscando por el nombre de la empresa o BPN.",
      "manufacturePartId": "ID de pieza del fabricante",
      "manufacturePartIdNote": "Busca todas las ofertas de datos que coincidan con el ID de pieza dado.",
      "enter": "Introduce {field}",
      "connectorUrl": "URL del conector",
      "connectorUrlNote": "Busca datos dentro de conectores específicos",
      "subModel": "Submodelo",
      "subModelNote": "Ajusta tus resultados de búsqueda para tu caso de uso deseado",
      "search": "Buscar",
      "searchBy": "Buscar por",
      "resetFilters": "Restablecer filtros",
      "advancedSearch": "Búsqueda avanzada",
      "name": "Nombre",
      "dct:type": "dct:type",
      "assetId": "ID de activo"
    },
    "noResult": {
      "title": "Sin resultados",
      "description": "Por favor, realiza una búsqueda para explorar las ofertas de datos disponibles en la red"
    },
    "helpCard": {
      "title": "¿Cómo funciona?",
      "description": "Descubre el catálogo de ofertas de datos de otros participantes del espacio de datos. Puedes buscar, seleccionar y suscribirte a las ofertas de datos disponibles en el espacio de datos.",
      "subtitle": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?",
      "documentation": "Documentación"
    },
    "offers": {
      "downloadSelected": "Descargar seleccionados",
      "transferSelected": "Transferir seleccionados",
      "negotiate": "Negociar",
      "noOffer": "No hay ofertas de datos disponibles."
    },
    "offer-details": {
      "title": "Confirmar negociaciones de contrato",
      "description": "Descripción",
      "details": "Detalles",
      "attachedPolicies": "Políticas adjuntas",
      "termsCheck": "Acepto los términos del contrato y deseo iniciar la negociación del contrato y el intercambio de datos.",
      "negotiate": "Negociar",
      "negotiateAndDownload": "Negociar y descargar",
      "negotiateAndTransfer": "Negociar y transferir",
      "transfer": "Transferir",
      "cancel": "Cancelar",
      "attribute": "Atributo",
      "value": "Valor",
      "endpointUrl": "URL del endpoint",
      "organization": "Organización",
      "bpnNumber": "Número BPN",
      "manufacturerPartId": "ID de pieza del fabricante",
      "noOfAssets": "Número de activos seleccionados",
      "membership": "Membresía",
      "dismantlerBrands": "Marcas permitidas para desmanteladores",
      "frameworkAgreement": "Acuerdo marco",
      "dismantler": "Desmantelador",
      "backToAssets": "Volver a activos",
      "noPolicyMatchTitle": "Activos no negociados o políticas no idénticas",
      "noPolicyMatchText": "Estás intentando descargar algunos activos que aún no están negociados. O algunos de los activos que intentas negociar no tienen políticas idénticas. Por favor, selecciona los activos correctos y continúa.",
      "negotiateInProgress": "Negociación y descarga en progreso",
      "negotiateAndDownloadSuccess": "Negociación y descarga completadas con éxito",
      "negotiateAndTransferSuccess": "Negociación y transferencia completadas con éxito",
      "transferSuccess": "Transferencia completada con éxito",
      "progress": "Progreso",
      "fetchShell": "Obtener shell",
      "exportToCSV": "Exportar a CSV",
      "fetchJobFailed": "Error al obtener detalles del trabajo",
      "negotiateError": "Error al descargar activos",
      "dtr": "Registro de gemelos digitales",
      "edc": "Activos del conector",
      "browseDtr": "Explorar DTR"
    },
    "dtr": {
      "title": "Gemelos digitales",
      "shells": "Explorar shells",
      "description": "Vas a negociar automáticamente la obtención y exportación de Shells del registro de gemelos digitales del proveedor seleccionado"
    }
  },
  "assetUploadHistory": {
    "title": "Historial de carga de activos",
    "subtitle": "Este historial muestra las transacciones en los conectores del espacio de datos de tu empresa. Todas las actividades en activos, políticas y definiciones de contrato se enumeran aquí.",
    "refresh": "Actualizar",
    "processId": "ID de proceso",
    "providerUrl": "URL del proveedor",
    "createdOn": "Creado en",
    "totalItems": "Total de elementos",
    "successful": "Exitoso",
    "failed": "Fallido",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de finalización",
    "status": "Estado",
    "actions": "Acciones",
    "howItWork": {
      "title": "¿Cómo funciona?",
      "description": "Puedes encontrar el historial de todos tus activos subidos en diferentes espacios de datos. Puedes volver a descargar los archivos localmente o transferirlos a una ubicación externa. En caso de errores, debes volver a intentar la descarga o renegociar la oferta de datos.",
      "moreInfo": "¿Quieres saber más sobre el historial de cargas y qué puedes hacer aquí?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "El historial te proporciona una visión general de los datos descargados de tu organización disponibles a partir de los contratos negociados en el espacio de datos. Si es necesario, puedes volver a descargar los datos desde esta lista de historial.",
    "howItWorks": {
      "description": "Puedes encontrar el historial de todos tus activos descargados en diferentes espacios de datos. Puedes volver a descargar los archivos localmente o transferirlos a una ubicación externa. En caso de errores, debes volver a intentar la descarga o renegociar la oferta de datos.",
      "moreInfo": "¿Quieres saber más sobre el historial de descargas y qué puedes hacer aquí?"
    },
    "downloadError": "Descarga no exitosa, ¡por favor, inténtalo de nuevo!",
    "viewErrors": "Ver errores"
  },
  "digitalTwinBrowser": {
    "subHeading": "Estos son tus gemelos digitales y sus submodelos. Tus gemelos digitales están expuestos al espacio de datos a través de tu Registro de Gemelos Digitales.",
    "noDocumentError": "No hay aspectDocument para el id actual",
    "nameNotProvided": "Nombre no proporcionado",
    "fetchDigitalTwinsError": "Error al obtener gemelos digitales",
    "fetchAspectDocumentError": "Error al obtener el documento de aspecto",
    "fetchAspectModelError": "Error al obtener el modelo de aspecto",
    "detailsOverviewModalTitle": "Detalles del aspecto",
    "addItem": "Agregar elemento",
    "detailsTable": {
      "id": "ID",
      "idShort": "ID corto",
      "displayName": "Nombre para mostrar",
      "modelUrn": "URN del modelo"
    },
    "shellsTable": {
      "id": "ID",
      "name": "Nombre",
      "manufacturer": "ID de pieza del fabricante",
      "modifiedBy": "Usuario",
      "modifiedAt": "Hora"
    }
  },
  "connector": {
    "addNewConnector": "+ Agregar nuevo conector",
    "searchConnector": "Buscar por nombre del conector",
    "connectorModal": {
      "error": "Error al obtener los detalles del conector"
    }
  },
  "column": {
    "name": "Nombre",
    "connectorName": "Nombre del conector",
    "contractId": "ID de contrato",
    "productId": "ID de producto",
    "manufacturerPartId": "ID de pieza del fabricante",
    "manufacturerId": "ID del fabricante",
    "digitalTwinType": "Tipo de gemelo digital",
    "correlationId": "ID de correlación",
    "requestId": "ID de solicitud",
    "bpn": "BPN",
    "createdAt": "Creado en",
    "createdBy": "Creado por",
    "attribute": "Atributo",
    "url": "URL",
    "actions": "Acciones",
    "lastUpdatedTime": "Última actualización",
    "status": "Estado",
    "requestedDate": "Fecha solicitada",
    "policyType": "Tipo de política",
    "modifiedBy": "Modificado por",
    "modifiedOn": "Modificado en",
    "syncStatus": "Estado de sincronización",
    "assetId": "ID de activo",
    "assetType": "Tipo de activo",
    "type": "Tipo",
    "createdFrom": "Creado desde",
    "createdTo": "Creado hasta",
    "statusDuration": "Estado/Duración",
    "certifier": "Certificador",
    "version": "Versión",
    "registrationNumber": "N.º de registro",
    "validUntil": "Válido hasta",
    "offerId": "Id. de oferta",
    "errorMessage": "Mensaje de error",
    "globalAssetId": "ID de activo global",
    "shellName": "Nombre del shell",
    "contractAgreementId": "ID de acuerdo de contrato",
    "signingDate": "Fecha de firma",
    "providerConnectorUrl": "URL del conector del proveedor",
    "consumerConnectorUrl": "URL del conector del consumidor",
    "providerBpnl": "BPNL del proveedor",
    "consumerBpnl": "BPNL del consumidor",
    "counterPartyId": "ID de contraparte",
    "resourceId": "ID de recurso",
    "resourceType": "Tipo de recurso",
    "transactionMethod": "Método de transacción",
    "trustLevel": "Nivel de confianza"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Error al obtener mensajes",
    "openRelatedMessage": "Abrir mensaje relacionado",
    "messagesTable": {
      "id": "Id",
      "name": "Nombre",
      "createdAt": "Creado en",
      "createdBy": "Creado por",
      "type": "Tipo",
      "context": "Contexto",
      "senderBpn": "BPN del remitente",
      "receiverBpn": "BPN del receptor",
      "correlationId": "ID de correlación",
      "jobId": "ID de trabajo",
      "conversationId": "ID de conversación",
      "status": "Estado"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "Genérico",
      "quality": "Calidad",
      "ccmpush": "CCM Push",
      "ccmrequest": "Solicitud CCM",
      "ccmstatus": "Estado CCM",
      "ccmavailable": "CCM Disponible"
    }
  },
  "bpnSelector": {
    "selectFromList": "Seleccionar de la lista",
    "enterManually": "Ingresar manualmente",
    "selectPlaceholder": "Seleccione una ubicación BPN",
    "manualPlaceholder": "Ingrese BPN (por ejemplo, BPNL123456789ABC)",
    "validFormat": "Formato BPN válido",
    "invalidFormat": "Formato BPN no válido",
    "invalidFormatHint": "Formato: BPNL + 12 caracteres alfanuméricos",
    "formatHint": "Formato: BPNL123456789ABC (16 caracteres en total)",
    "selected": "Seleccionado"
  },
  "searchableSelect": {
    "pressEnterToUse": "Presione Enter para usar este BPNA/BPNS",
    "placeholderText": "Por favor ingrese un BPNA/BPNS válido",
    "placeholder": "Seleccione o ingrese un BPNA/BPNS"
  }
}
